import { Box } from '@mui/material';
import DomainDetailsComponent from './domain_details';
import { RootState } from '../../redux/store';
import SiteSettingsComponent from './site_settings';
import StepperComponent from '../reusable/stepper';
import { useSelector } from 'react-redux';

const ConnectDomainComponent = () => {
    const { flags, domain } = useSelector((state: RootState) => state.domain);

    return <Box display="flex" flexDirection="column" gap={3}>
        <Box mt={2}>
            {!domain && <StepperComponent
                steps={[
                    '1',
                    '2'
                ]}
                activeStep={flags.selectedIndex}
            />}
        </Box>
        {
            flags.selectedIndex === 0 ? (<DomainDetailsComponent />) : (<SiteSettingsComponent />)
        }
    </Box>;
};

export default ConnectDomainComponent;